import { logo_partner } from "@/constants/imagesUrl";
import Image from "next/image";
const BrandItem = () => {
  return (
    <>
      {Object.entries(logo_partner).map(([key, src]) => (
        <div
          key={key}
          className="h-auto md:w-[158px] w-[100px] hover:rounded-3xl hover:shadow-lg"
        >
          <div className="flex justify-center rounded-3xl items-center h-[62px] w-full  filter ease-in-out hover:shadow-lg hover:grayscale-0 transition duration-300 hover:rounded-3xl">
            <Image
              src={src}
              width={100}
              height={62}
              className="max-h-[62px] max-w-[158px] w-auto h-auto px-2 py-2 object-contain"
              alt={key}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default BrandItem;
